<template>
	<div class="modal fade" id="cancelCoordinationModal" role="dialog" aria-labelledby="cancelCoordinationModalLabel" data-backdrop="static" aria-hidden="true">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="cancelCoordinationModalLabel">{{$t('coordinations.cancelation')}}</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div>
						<div class="row">
							<div class="col-md-12 form-group">
								<label class="font-weight-bold">{{$t('coordinations.cancelConfirm')}}</label>
							</div>
							<div class="col-md-12 form-group">
								<div class="font-weight-bold">{{$t('coordinations.cancelationReason')}}</div>
								<div class="mb-3">
									<textarea v-model="comment" class="form-control"></textarea>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<vs-button color="success" type="filled" @click="onAcceptClick">{{$t('buttons.ok')}}</vs-button>
					<vs-button color="danger" type="filled" @click="onRejectClick">{{$t('buttons.cancel')}}</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import coordinationsService from '@/services/coordinations.service';
import { Coordination } from '@/models/models';

export default {
	props: {
		value: {},
		show: {
			type: Boolean,
			required: false
		}
	},
	data() {
		return {
			model: new Coordination(),
			isLoading: false,
			comment: ''
		};
	},
	methods: {
		onAcceptClick() {
			this.sendAnswer();
		},
		onRejectClick() {
			this.hide();
		},
		sendAnswer() {
			this.isLoading = true;

			coordinationsService
				.cancel({
					coordinationId: this.value,
					comment: this.comment
				})
				.then(data => {
					this.$vs.notify({
						color: 'success',
						title: this.$t('updateSuccess'),
						text: ''
					});
					this.$emit('updated', this.model);
					this.hide();
				})
				.catch(err =>
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				);
		},
		hide() {
			this.comment = null;
			$(this.$el).modal('hide');
		},
		onClose() {
			this.$emit('update:show', false);
			this.$emit('onClose');
		}
	},
	mounted() {
		// add modal close listener
		$(this.$el).on('hidden.bs.modal', this.onClose);
	},
	beforeDestroy() {
		// remove listener
		$(this.$el).off('hidden.bs.modal');
	},
	watch: {
		show: function(val) {
			this.comment = null;
			$(this.$el).modal(val ? 'show' : 'hide');
		}
	}
};
</script>

<style lang="scss" scoped>
.radio-message {
	padding: 3px 3px 3px 5px;
	border-left: 3px solid #03a9f4;
	box-shadow: 1px 1px 1px 1px lightgrey;
}

div.radio label {
	color: inherit;
	cursor: pointer;
}

.bmd-form-group {
	padding-top: 1rem !important;
}
</style>
